import { type FC, type PropsWithChildren, useEffect } from 'react';
import useMeasure from 'react-use-measure';

import { setCssVar } from '@/common/lib/cssVar';
import { ResourceTitle } from '@/components/ResourceTitle/ResourceTitle';

const WorkshopTitle: FC<PropsWithChildren> = ({ children }) => {
  const [titleRef, measure] = useMeasure();

  useEffect(() => {
    setCssVar('--workshop-title-height', `${measure.height}px`);
  }, [measure]);

  return <ResourceTitle ref={titleRef}>{children}</ResourceTitle>;
};

export { WorkshopTitle };
